

export const PolicyTypes = [
    { id: 1, name: "Framework Policy" },
    { id: 2, name: "Named Multibuyer Portfolio" },
    { id: 3, name: "Whole Turnover" },
    { id: 4, name: "Single Risk" }
];

export const DocumentTypes = [
    { id: 1, name: 'Policy Declarations' },
    { id: 2, name: 'Policy' },
    { id: 3, name: 'Country Schedule' },
    { id: 4, name: 'Seller Schedule' },
    { id: 5, name: 'DCL Endorsement' },
    { id: 6, name: 'Ledger DCL Endorsement' },
    { id: 7, name: 'Loss Payee Endorsement' },
    { id: 8, name: 'Additional Named Insured Endorsement' },
    { id: 9, name: 'Preference Claims Endorsement' },
    { id: 10, name: 'Sanctions Endorsement' },
    { id: 11, name: 'LQX Endorsement' },
    { id: 12, name: 'Broker Endorsement' },
    { id: 13, name: 'Premium Schedule' },
    { id: 14, name: 'Other' }
];

export const CoveredAssetTypes = [
    { id: 1, name: 'A/R' },
    { id: 2, name: 'SCF' },
    { id: 3, name: 'L/Cs' },
    { id: 4, name: 'Trade Loans' }
];

export const PolicyAttachmentTypes = [
    { id: 1, name: 'Date Financier Purchases Asset' },
    { id: 2, name: 'Shipment Date' },
    { id: 3, name: 'Invoice Date' },
    { id: 4, name: 'Delivery Date' },
    { id: 5, name: 'Not Applicable' }
];

export const PolicyDeductibleTypes = [
    { id: 1, name: 'Yes - % of aggregate losses' },
    { id: 2, name: 'Yes - % of each and every loss' },
    { id: 3, name: 'Yes - Amount of aggregate losses' },
    { id: 4, name: 'Yes - Amount of each and every loss' },
    { id: 5, name: 'No' }
];

export const PremiumBasisTypes = [
    { id: 1, name: 'Gross Limit' },
    { id: 2, name: 'Net Limit' },
    { id: 3, name: 'Insurable Sales' },
    { id: 4, name: 'Month End A/R Balances' },
    { id: 5, name: 'Month End Gross Exposure' },
    { id: 6, name: 'Month End Net Exposure' },
    { id: 7, name: 'Monthly Peak A/R' },
    { id: 8, name: 'Utilization' }
];

export const ReportPeriodTypes = [
    { id: 1, name: 'Monthly' },
    { id: 2, name: 'Quarterly' },
    { id: 3, name: 'Semi-Annually' },
    { id: 4, name: 'Annually' },
    { id: 5, name: 'Custom' }
];

export const ScopeOfCoverageTypes = [
    { id: 1, name: 'Domestic' },
    { id: 2, name: 'Multicountry' },
    { id: 3, name: 'Not Applicable' }
];

export const SyndicationRuleTypes = [
    { id: 1, name: 'Each Limit' }
];

export const YesNoTypes = [
    { id: 1, name: 'Yes' },
    { id: 2, name: 'No' }
];

export const PaymentTypes = [
    { id: 1, name: 'Cure' },
    { id: 2, name: 'Credit applied' },
    { id: 3, name: 'Funding' },
    { id: 4, name: 'Repurchase' },
    { id: 5, name: 'Remittance' },
    { id: 6, name: 'Direct Payment' }
];

export const PaymentMethods = [
    { id: 1, name: 'ACH' },
    { id: 2, name: 'Wire' },
    { id: 3, name: 'Check' }
];